// API-base shim voor productie-deploys (bv. Render static site).
//
// De meeste API-calls in App.jsx zijn RELATIEF ('/api/...') en leunen lokaal op
// de nginx-proxy (docker-compose) die '/api/' naar de backend stuurt. In een
// productie-opzet waarbij de frontend als losse static site op een ANDER domein
// draait dan de API (zoals de Render-config), bestaat die proxy niet → relatieve
// calls zouden naar het frontend-domein gaan en falen.
//
// Deze shim stuurt zulke relatieve '/api/...'-calls naar de absolute API-URL uit
// REACT_APP_API_URL. Is die env-var niet gezet (lokaal/dev), dan blijft alles
// ongewijzigd en werkt de nginx-proxy gewoon. De auth-helper (src/auth/api.js)
// gebruikt REACT_APP_API_URL al rechtstreeks en blijft dus ook werken.
const API_BASE = (process.env.REACT_APP_API_URL || '').replace(/\/+$/, '');

if (API_BASE && typeof window !== 'undefined' && typeof window.fetch === 'function') {
  const nativeFetch = window.fetch.bind(window);
  window.fetch = (input, init) =>
    (typeof input === 'string' && input.startsWith('/api/'))
      ? nativeFetch(API_BASE + input, init)
      : nativeFetch(input, init);
}

export default API_BASE;
